var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-select',{attrs:{"options":_vm.options},model:{value:(_vm.selectedSync),callback:function ($$v) {_vm.selectedSync=$$v},expression:"selectedSync"}})
}
var staticRenderFns = []

export { render, staticRenderFns }